var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("illustration-" + _vm.orientation)},[_c('section',{staticClass:"parallax-wrap"},[_c('div',{staticClass:"viewport"},[_c('figure',{staticClass:"figure screen"},[_vm._t("image")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }